export default __webpack_public_path__ + "static/media/jackpot-mobile-ms.2cb39a59.webp";